import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NGXLogger } from "ngx-logger";
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { EnvironmentService } from './environmet.service';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
}

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(private http: HttpClient, private logger: NGXLogger) { }

  public get(url: string): Observable<any> {
    this.logger.trace('HttpService.get', url)
    return this.http.get(url);
  }

  public post(url: string, data: string): Observable<any> {
    this.logger.trace('HttpService.post', url)
    return this.http.post(url, data);
  }

  public getFromApi(url: string): Observable<any> {
    this.logger.trace('HttpService.getFromApi', url)
    return this.http.get(EnvironmentService.environment.baseApiUrl + url)
      .pipe(tap({ error: (error) => this.handleError(error) }));
  }

  public postToApiFile(url: string, data: string): Observable<any> {
    this.logger.trace('HttpService.postToApi', url)
    return this.http.post(EnvironmentService.environment.baseApiUrl + url, data, { headers: { 'Content-Type': 'application/json' }, responseType: 'blob' })
      .pipe(tap({ error: (error) => this.handleError(error) }));
  }

  public postToApi(url: string, data: string): Observable<any> {
    this.logger.trace('HttpService.postToApi', url)
    return this.http.post(EnvironmentService.environment.baseApiUrl + url, data, httpOptions)
      .pipe(tap({ error: (error) => this.handleError(error) }));
  }

  public postFormDataToApi(url: string, formData: FormData): Observable<any> {
    this.logger.trace('HttpService.postFormDataToApi', url)
    const uploadReq = new HttpRequest(
      'POST',
      EnvironmentService.environment.baseApiUrl + url,
      formData
    );
    return this.http.request(uploadReq)
      .pipe(tap({ error: (error) => this.handleError(error) }));
  }

  public getBlobFromApi(url: string): Observable<any> {
    this.logger.trace('HttpService.getBlobFromApi', url)
    return this.http.get(EnvironmentService.environment.baseApiUrl + url, { responseType: 'blob' })
      .pipe(tap({ error: (error) => this.handleError(error) }));
  }


  private handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    this.logger.error(errorMessage);
  }
}
